import { Button as StyledComponentButton } from '@ui-component-library/components/_deprecated/Button';
import { Icon as StyledComponentIcon } from '@ui-component-library/components/_deprecated/Icon';
import { IconButton as StyledComponentIconButton } from '@ui-component-library/components/_deprecated/IconButton';
import { Input as StyledComponentInput } from '@ui-component-library/components/_deprecated/Input';
import { Link as StyledComponentLink } from '@ui-component-library/components/_deprecated/Link';
import { List as StyledComponentList } from '@ui-component-library/components/_deprecated/List';
import { Modal as StyledComponentModal } from '@ui-component-library/components/_deprecated/Modal';
import { Progressbar as StyledComponentProgressbar } from '@ui-component-library/components/_deprecated/Progressbar';
import { SearchDropdown as StyledComponentSearch } from '@ui-component-library/components/_deprecated/SearchDropdown';
import { Selector as StyledComponentSelector } from '@ui-component-library/components/_deprecated/Selector';
import { TermsCheckbox as StyledComponentTermsCheckbox } from '@ui-component-library/components/_deprecated/TermsCheckbox';
import { Textarea as StyledComponentTextarea } from '@ui-component-library/components/_deprecated/Textarea';
import { Tooltip as StyledComponentTooltip } from '@ui-component-library/components/_deprecated/Tooltip';
import { Typography as StyledComponentTypography } from '@ui-component-library/components/_deprecated/Typography';
import { Accordion as twAccordion } from '@ui-component-library/components/Accordion';
import { Alert as twAlert } from '@ui-component-library/components/Alert';
import { Button as twButton } from '@ui-component-library/components/Button';
import { Checkbox as TwCheckbox } from '@ui-component-library/components/Checkbox';
import { Chip as TwChip } from '@ui-component-library/components/Chip';
import { Dialog as twDialog } from '@ui-component-library/components/Dialog';
import { Drawer as TwDrawer } from '@ui-component-library/components/Drawer';
import { Dropdown as twDropdown } from '@ui-component-library/components/Dropdown';
import { FileUpload as twFileUpload } from '@ui-component-library/components/FileUpload';
import { HelperText as TwHelperText } from '@ui-component-library/components/HelperText';
import { Icon as twIcon } from '@ui-component-library/components/Icon';
import { Input as twInput } from '@ui-component-library/components/Input';
import { InputOTP as twInputOTP } from '@ui-component-library/components/InputOTP';
import { Link as twLink } from '@ui-component-library/components/Link';
import { List as twList } from '@ui-component-library/components/List';
import { Modal as twModal } from '@ui-component-library/components/Modal';
import { PaginationDots as TwPaginationDots } from '@ui-component-library/components/PaginationDots';
import { Popover as twPopover } from '@ui-component-library/components/Popover';
import { Progressbar as twProgressbar } from '@ui-component-library/components/Progressbar';
import { RadioButton as TwRadioButton } from '@ui-component-library/components/RadioButton';
import { SearchInput as TwSearchInput } from '@ui-component-library/components/SearchInput';
import { Selector as twSelector } from '@ui-component-library/components/Selector';
import { Sheet as TwSheet } from '@ui-component-library/components/Sheet';
import {
  Slider as TwSlider,
  useSliderController as TwUseSlider
} from '@ui-component-library/components/Slider';
import { SliderBar as TwSliderBar } from '@ui-component-library/components/SliderBar';
import { Switch as twSwitch } from '@ui-component-library/components/Switch';
import { Table as twTable } from '@ui-component-library/components/Table';
import { Tabs as twTabs } from '@ui-component-library/components/Tabs';
import { Text as BaseText } from '@ui-component-library/components/Text';
import { Textarea as twTextarea } from '@ui-component-library/components/Textarea';
import {
  showToast as twShowToast,
  Toaster as twToaster
} from '@ui-component-library/components/Toast';
import { Tooltip as TwTooltip } from '@ui-component-library/components/Tooltip';
import { withStyleComponentFallback } from '@ui-component-library/utils/withStyleComponentFallack';
import { withTailwindWrapper } from '@ui-component-library/utils/withTailwindWrapper';

import { BarsChart } from './components/Chart/lib';
import { LinesChart } from './components/Chart/lib';
import { PiesChart } from './components/Chart/lib';

/* Colors */
export { default as COLORS } from './styles/colors';

/* Text variants */
export { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

/* Components - Styled components */
export { Dropdown } from '@ui-component-library/components/_deprecated/Dropdown';
export { InfoTile } from '@ui-component-library/components/InfoTile';

export { ListPanel } from '@ui-component-library/components/ListPanel';
export { Loader } from '@ui-component-library/components/Loader';
export { PulseHighlight } from '@ui-component-library/components/PulseHighlight';

export { Summary } from '@ui-component-library/components/Summary';
export { Tabs } from '@ui-component-library/components/_deprecated/Tabs';

/* 
  Deprecated styled-components exports. 
  Use Tailwind versions where available; 
  fallback provided for incomplete migrations in example-components.
*/
export const IconButton = StyledComponentIconButton;
export const TermsCheckbox = StyledComponentTermsCheckbox;
export const SearchDropdown = StyledComponentSearch;

// With fallback for incomplete migrations in example-components
export const Button = withStyleComponentFallback(twButton, StyledComponentButton);
export const TwButton = twButton;
export const Icon = withStyleComponentFallback(twIcon, StyledComponentIcon);
export const Input = withStyleComponentFallback(twInput, StyledComponentInput);
export const Link = withStyleComponentFallback(twLink, StyledComponentLink);
export const List = withStyleComponentFallback(twList, StyledComponentList);
export const Modal = withStyleComponentFallback(twModal, StyledComponentModal);
export const Progressbar = withStyleComponentFallback(twProgressbar, StyledComponentProgressbar);
export const Selector = StyledComponentSelector;
export const Textarea = withStyleComponentFallback(twTextarea, StyledComponentTextarea);
export const Tooltip = withStyleComponentFallback(TwTooltip, StyledComponentTooltip);
export const Typography = StyledComponentTypography;

// Fully converted to Tailwind
export const Accordion = twAccordion;
export const BarChart = BarsChart;
export const Checkbox = withTailwindWrapper(TwCheckbox);
export const Chip = withTailwindWrapper(TwChip);
export const Dialog = twDialog;
export const Drawer = TwDrawer;
export const HelperText = withTailwindWrapper(TwHelperText);
export const InputOTP = withTailwindWrapper(twInputOTP);
export const LineChart = LinesChart;
export const PaginationDots = withTailwindWrapper(TwPaginationDots);
export const PieChart = PiesChart;
export const RadioButton = withTailwindWrapper(TwRadioButton);
export const SearchInput = withTailwindWrapper(TwSearchInput);
export const Sheet = TwSheet;
export const Slider = TwSlider;
export const SliderBar = TwSliderBar;
export const Switch = withTailwindWrapper(twSwitch);
export const Table = twTable;
export const Text = withTailwindWrapper(BaseText);
export const TwAlert = twAlert;
export const TwDropdown = twDropdown;
export const TwFileUpload = twFileUpload;
export const TwModal = twModal;
export const TwSelector = twSelector;
export const TwTabs = twTabs;
export const Popover = withTailwindWrapper(twPopover);
export const Toaster = twToaster;
export const showToast = twShowToast;

// Text variants
export { TextVariants } from '@ui-component-library/components/Text';

// Hooks
export const useSliderController = TwUseSlider;
